<template>
  <div>
    <CreateType/>
    <CreateField/>
  </div>
</template>

<script>
import CreateField from './createField'
import CreateType from './createType'
export default {
  name: 'customer-settings',
  components: {
    CreateField,
    CreateType
  }
}
</script>

<style>
</style>
